<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="昵称">
        <el-input placeholder="请输入昵称" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>
    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="昵称" prop="UNickName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.UNickName || '-' }}</span>

        </template>
      </el-table-column>
      <el-table-column label="性别" prop="USex" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.USex === 1" type="primary" size="small">男</el-tag>
          <el-tag v-else-if="row.USex === 0" type="danger" size="small">女</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="城市" prop="UCity" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.uCity || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="UPhone" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.UPhone || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="头像" prop="UImg" align="center">
        <template slot-scope="{ row }">
          <el-image v-if="row.UImg" :src="row.UImg" :preview-src-list="[row.uImg]" fit="cover" class="user-avatar-img">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="State" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.State === 1" type="success" size="small">正常</el-tag>
          <el-tag v-else-if="row.State === 0" type="danger" size="small">禁用</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="创建IP" prop="UCreateIp" align="center" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.UCreateIp || '-' }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="最后登录IP" prop="ULastIp" align="center" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.ULastIp || '-' }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="创建时间" prop="CreateTime"></el-table-column>
      <el-table-column label="最后登录时间" prop="ULastTime"></el-table-column>

    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetJngWxUserPageList } from "@/api/dev_data_view"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },

  data() {
    return {
      tableData: [],
      filter: {
        groupName: ""
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {

    // 处理是否开启不生产订单状态变化
    getData() {
      this.loading = true
      GetJngWxUserPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      })
        .then((res) => {
          this.tableData = res.data || []
          this.pageParams.total = res.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 添加分页相关方法
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },

    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },

    toFilter() {
      this.pageParams.page = 1
      this.getData()
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.input-small {
  width: 200px;
}

.ml-10 {
  margin-left: 10px;
}

/* 用户昵称单元格样式 */
.nickname-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.user-avatar {
  flex-shrink: 0;
}

/* 头像图片样式 */
.user-avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 20px;
}
</style>